import React, { useRef } from "react";
import SwiperCore from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

import { Swiper, SwiperSlide } from "swiper/react";

import CardWithBgImage from "../../cards/cardWithBgImage";
import { Link } from "utils/customLink";
import { useTheme } from "context/ThemeContext";
import PlanetComingSoonImg from "images/homepage/planet_coming_soon.jpg";
import PeopleComingSoonImg from "images/homepage/people_coming_soon.jpg";

import "swiper/css/bundle";
import "swiper/css/navigation";
import "swiper/css/pagination";

SwiperCore.use([Autoplay, Pagination, Navigation]);

const ProgramSlides = ({ relatedPrograms }) => {
  const swiperRef = useRef(null);
  const { colorMode } = useTheme();

  const comingSoonProgram = {
    title: "Exciting new programs coming soon.",
    image: colorMode === "light" ? PeopleComingSoonImg : PlanetComingSoonImg,
    uri: "/volunteer-abroad",
    placeholder: true
  };

  const programs = [...relatedPrograms];
  while (programs.length < 3) {
    programs.push(comingSoonProgram);
  }

  return (
    <div
      className="flex-col justify-center sm:flex sm:h-full"
      key={"program-slides"}
    >
      <div className="container flex flex-col w-full mx-auto">
        <div className="relative w-full related-programs-swiper-container h-80">
          {programs && programs?.length > 2 && (
            <Swiper
              ref={swiperRef}
              grabCursor={true}
              centeredSlides={false}
              slidesPerView={1.5}
              spaceBetween={10}
              pagination={{
                clickable: true,
                dynamicBullets: true
              }}
              loop={true}
              className="related-programs-swiper h-[380px] justify-center items-center pb-14 sm:!py-2"
              breakpoints={{
                640: {
                  slidesPerView: 3,
                  spaceBetween: 0,
                  navigation: true,
                  centeredSlides: false
                }
              }}
            >
              {programs?.map((programDet, index) => {
                const title = programDet?.title;
                const fallbackImage =
                  programDet?.featuredImage?.node?.sourceUrl;
                const scaledImage =
                  programDet?.featuredImage?.node?.gatsbyImage;
                const featuredImage = programDet?.featuredImage?.node?.localFile
                  ?.extension
                  ? programDet?.featuredImage?.node?.localFile
                  : fallbackImage;
                const programUri = programDet?.uri;
                const programType = programDet?.programType?.map(
                  (type) => type.title
                );

                if (!featuredImage && !fallbackImage) {
                  return <></>;
                }

                return (
                  <SwiperSlide key={index}>
                    <Link to={programUri}>
                      <CardWithBgImage
                        scaledImage={scaledImage}
                        featuredImage={featuredImage}
                        title={title}
                        programType={programType}
                        featuredImageFallback={fallbackImage}
                        isComingSoon={programDet.placeholder}
                      />
                    </Link>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          )}
          {programs?.length >= 2 && (
            <>
              <div
                className="swiper-button-prev rotate-180 !-left-12 !w-11 h-11  after:hidden !hidden lg:!block"
                onClick={() => swiperRef.current.swiper.slidePrev()}
              />
              <div
                className="swiper-button-next !w-11 h-11 after:hidden !hidden lg:!block"
                onClick={() =>
                  programs.length > 3
                    ? swiperRef.current.swiper.slideNext()
                    : swiperRef.current.swiper.slidePrev()
                }
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProgramSlides;
